export default {
  'cdn.ops.dashboard.overview.error':
    'Overview failed to load. Retrying; existing data may be stale.',
  'cdn.ops.dashboard.nodes.error': 'Failed to load node sample',
  'cdn.ops.dashboard.abnormal.sampleTitle':
    'Abnormal nodes (sample from the first node page)',
  'cdn.ops.dashboard.abnormal.sampleEmpty': 'No abnormal nodes in this sample',
  'cdn.https.cert.title': 'Certificate information',
  'cdn.https.cert.mode': 'Site certificate mode',
  'cdn.https.cert.auto': 'Automatic issuance',
  'cdn.https.cert.manual': 'Manual certificate',
  'cdn.https.cert.httpsDisabled': 'HTTPS disabled',
  'cdn.https.cert.savedConfigTip':
    'Based on saved configuration and certificate records; this does not confirm loading on every edge node.',
  'cdn.https.cert.autoTip':
    'Certificates are issued and renewed per domain. Forced HTTPS redirects wait for a usable certificate; direct HTTPS access may still fail before issuance.',
  'cdn.https.cert.refresh': 'Refresh',
  'cdn.https.cert.loadFailed': 'Unable to load certificates. Refresh to retry.',
  'cdn.https.cert.domain': 'Domain',
  'cdn.https.cert.domains': 'Certificate domains',
  'cdn.https.cert.status': 'Certificate status',
  'cdn.https.cert.issuer': 'Issuer',
  'cdn.https.cert.notBefore': 'Valid from',
  'cdn.https.cert.notAfter': 'Expires at',
  'cdn.https.cert.remaining': 'Time remaining',
  'cdn.https.cert.days': '{days} days',
  'cdn.https.cert.lessThanDay': 'Less than 1 day',
  'cdn.https.cert.attempt': 'Latest issuance / renewal',
  'cdn.https.cert.reason': 'Notes',
  'cdn.https.cert.operation': 'Actions',
  'cdn.https.cert.details': 'View details',
  'cdn.https.cert.keyMatches': 'Certificate / private key',
  'cdn.https.cert.matched': 'Matching',
  'cdn.https.cert.mismatched': 'Mismatched or invalid key',
  'cdn.https.cert.renewal': 'Update method',
  'cdn.https.cert.autoRenewal': 'Automatic renewal',
  'cdn.https.cert.manualRenewal': 'Manual replacement',
  'cdn.https.cert.coverage': 'Certificate coverage',
  'cdn.https.cert.coverageTitle': 'Site domain coverage',
  'cdn.https.cert.covered': 'Covered',
  'cdn.https.cert.uncovered': 'Not covered',
  'cdn.https.cert.uncoveredTip':
    'The manual certificate does not cover all site domains. HTTPS access to uncovered domains may fail.',
  'cdn.https.cert.domainState': 'Domain status',
  'cdn.https.cert.domainReady': 'Enabled and verified',
  'cdn.https.cert.recordId': 'Certificate record ID',
  'cdn.https.cert.subject': 'Subject',
  'cdn.https.cert.serial': 'Serial number',
  'cdn.https.cert.fingerprint': 'SHA-256 fingerprint',
  'cdn.https.cert.publicKeyAlgorithm': 'Public key algorithm',
  'cdn.https.cert.signatureAlgorithm': 'Signature algorithm',
  'cdn.https.cert.provider': 'ACME provider ID',
  'cdn.https.cert.lastAttempt': 'Latest issuance / renewal record time',
  'cdn.https.cert.lastError': 'Latest error',
  'cdn.https.cert.status.valid': 'Valid',
  'cdn.https.cert.status.expiring': 'Expiring soon',
  'cdn.https.cert.status.expired': 'Expired',
  'cdn.https.cert.status.not_yet_valid': 'Not yet valid',
  'cdn.https.cert.status.pending': 'Issuing',
  'cdn.https.cert.status.failed': 'Issuance failed',
  'cdn.https.cert.status.invalid': 'Invalid certificate',
  'cdn.https.cert.status.missing': 'Not configured / not requested',
  'cdn.https.cert.status.revoked': 'Revoked (record status)',
  'cdn.https.cert.status.unknown': 'Unknown',
  'cdn.https.cert.attempt.success': 'Issued',
  'cdn.https.cert.attempt.pending': 'In progress',
  'cdn.https.cert.attempt.failed': 'Failed',
  'cdn.https.cert.attempt.none': 'No record',
  'cdn.https.cert.reason.domain_disabled': 'Domain disabled',
  'cdn.https.cert.reason.domain_unverified': 'Domain not verified',
  'cdn.https.cert.reason.site_inactive': 'Site not active',
  'cdn.https.cert.reason.https_disabled': 'HTTPS disabled',
  'cdn.https.cert.reason.awaiting_certificate':
    'Waiting for a usable certificate',
  'cdn.site.line.column.description': 'Line Description',
  'cdn.domain.verification.title': 'Domain Verification Configuration',
  'cdn.domain.verification.domain': 'Domain',
  'cdn.domain.verification.method': 'Verification Method',
  'cdn.domain.verification.method.cname': 'CNAME Verification',
  'cdn.domain.verification.method.txt': 'TXT Record Verification',
  'cdn.domain.verification.txt.recordType': 'Record Type',
  'cdn.domain.verification.txt.hostRecord': 'Host Record',
  'cdn.domain.verification.txt.recordValue': 'Record Value',
  'cdn.domain.verification.txt.instructions':
    'Please configure the following TXT record in your DNS provider:',
  'cdn.domain.verification.copy': 'Copy Configuration',
  'cdn.domain.verification.verifyNow': 'Verify Now',
  'cdn.domain.verification.cancel': 'Cancel',
  'cdn.domain.verification.getVerificationInfo': 'Get Verification Info',
  'cdn.domain.verification.success': 'Verification successful',
  'cdn.domain.verification.failed': 'Verification failed',
  'cdn.domain.verification.txtNotMatch':
    'TXT record value does not match, please check DNS configuration',
  'cdn.domain.verification.cnameNotMatch':
    'CNAME record does not match, please check DNS configuration',
  'cdn.domain.verification.dnsCheckFailed': 'DNS lookup failed',
  'cdn.domain.verification.cname.instructions':
    'CNAME verification requires pointing your domain to the line CNAME address configured for the site. Please configure lines in "Line Management" and set your domain CNAME record to the corresponding line address.',
  'cdn.domain.verification.tutorial.title': 'Configuration Tutorial',
  'cdn.domain.verification.tutorial.description':
    'Below are configuration examples from different DNS providers for your reference. Common DNS providers include: Alibaba Cloud, Tencent Cloud, Huawei Cloud, Baidu Cloud.',
  'cdn.domain.verification.tutorial.aliyun': 'Alibaba Cloud',
  'cdn.domain.verification.tutorial.tx': 'Tencent Cloud',
  'cdn.domain.verification.tutorial.hw': 'Huawei Cloud',
  'cdn.domain.verification.tutorial.bd': 'Baidu Cloud',

  // Upstream node error codes
  'cdn.upstream.error.ADDRESS_REQUIRED': 'Upstream address is required',
  'cdn.upstream.error.PORT_INVALID': 'Port must be between 1 and 65535',
  'cdn.upstream.error.WEIGHT_INVALID': 'Weight must be between 0 and {max}',
  'cdn.upstream.error.TLS_SERVER_NAME_TOO_LONG':
    'TLS server name must not exceed {max} characters',
  'cdn.upstream.error.DIAL_TIMEOUT_INVALID':
    'Dial timeout must be between 0 and {max} ms',
  'cdn.upstream.error.RESPONSE_HEADER_TIMEOUT_INVALID':
    'Response header timeout must be between 0 and {max} ms',
  'cdn.upstream.error.MAX_CONNS_PER_HOST_INVALID':
    'Max connections per host must be between 0 and {max}',
  'cdn.upstream.error.H2C_HTTPS_CONFLICT':
    'H2C and HTTPS cannot be enabled at the same time',
  'cdn.upstream.error.H2C_HTTP3_CONFLICT':
    'H2C and HTTP/3 cannot be enabled at the same time',
  'cdn.upstream.error.FORCE_HTTP2_H2C_CONFLICT':
    'ForceAttemptHTTP2 and H2C cannot be enabled at the same time',
  'cdn.upstream.error.CERT_KEY_MISMATCH':
    'TLS certificate and private key must be provided together',
  'cdn.upstream.error.TLS_CERT_WITHOUT_HTTPS':
    'TLS certificate/CA can only be used when HTTPS is enabled',
  'cdn.upstream.error.SKIP_VERIFY_WITH_CA':
    'Cannot set both tls_skip_verify and a custom CA certificate',
  'cdn.upstream.error.TLS_SERVER_NAME_WITHOUT_HTTPS':
    'TLS server name can only be set when HTTPS is enabled',

  // Upstream node field tooltips
  'cdn.upstream.field.weight.tooltip': 'Range 0~10000, default 1',
  'cdn.upstream.field.dial_timeout.tooltip':
    'Connection timeout (ms), default 3000 (3s)',
  'cdn.upstream.field.response_header_timeout.tooltip':
    'Response header timeout (ms), default 30000 (30s)',
  'cdn.upstream.field.max_conns_per_host.tooltip':
    'Max concurrent connections per host, 0 for unlimited',
  'cdn.upstream.field.tls_server_name.tooltip':
    'TLS SNI server name, max 255 characters',
  'cdn.upstream.field.enable_h2c.tooltip':
    'Clear-text HTTP/2, conflicts with HTTPS and HTTP/3',
  'cdn.upstream.field.enable_http3.tooltip':
    'HTTP/3 (QUIC), will auto-enable HTTPS',
  'cdn.upstream.field.force_attempt_http2.tooltip':
    'Force HTTP/2 upgrade, conflicts with H2C',
  'cdn.upstream.field.hostname.tooltip':
    'Host header value, different from TLS SNI (tls_server_name)',

  // Common
  'cdn.common.confirm': 'OK',
  'cdn.common.cancel': 'Cancel',
  'cdn.common.delete': 'Delete',
  'cdn.common.edit': 'Edit',
  'cdn.common.detail': 'Detail',
  'cdn.common.save': 'Save',
  'cdn.common.saveConfig': 'Save Configuration',
  'cdn.common.enable': 'Enable',
  'cdn.common.disable': 'Disable',
  'cdn.common.enabled': 'Enabled',
  'cdn.common.disabled': 'Disabled',
  'cdn.common.status': 'Status',
  'cdn.common.operation': 'Actions',
  'cdn.common.copySuccess': 'Copied',
  'cdn.common.name': 'Name',
  'cdn.common.description': 'Description',
  'cdn.common.type': 'Type',
  'cdn.common.content': 'Content',
  'cdn.common.action': 'Action',
  'cdn.common.redirectUrl': 'Redirect URL',
  'cdn.common.addRule': 'Add Rule',
  'cdn.common.deleteConfirm': 'Are you sure you want to delete this rule?',
  'cdn.common.deleteSuccess': 'Deleted successfully',
  'cdn.common.deleteFailed': 'Delete failed',
  'cdn.common.createSuccess': 'Created successfully',
  'cdn.common.createFailed': 'Create failed',
  'cdn.common.updateSuccess': 'Updated successfully',
  'cdn.common.updateFailed': 'Update failed',
  'cdn.common.saveSuccess': 'Saved successfully',
  'cdn.common.saveFailed': 'Save failed',
  'cdn.common.fetchFailed': 'Failed to fetch configuration',
  'cdn.common.allow': 'Allow',
  'cdn.common.deny': 'Deny',
  'cdn.common.redirect': 'Redirect',
  'cdn.common.operationFailed': 'Operation failed',
  'cdn.common.yes': 'Yes',
  'cdn.common.no': 'No',

  // Match modes
  'cdn.match.ip': 'IP',
  'cdn.match.ip_group': 'IP Group',
  'cdn.match.uri': 'URI',
  'cdn.match.full_uri': 'Full URI',
  'cdn.match.uri_param': 'URI Parameter',
  'cdn.match.user_agent': 'User-Agent',
  'cdn.match.referer': 'Referer',
  'cdn.match.header': 'Request Header',
  'cdn.match.equals': 'Equals',
  'cdn.match.not_equals': 'Not Equals',
  'cdn.match.starts_with': 'Starts With',
  'cdn.match.ends_with': 'Ends With',
  'cdn.match.contains': 'Contains',
  'cdn.match.regex': 'Regex',
  'cdn.match.in': 'In List',
  'cdn.match.not_in': 'Not In List',

  // Verify policy
  'cdn.verify.click': 'Click Verify (Default)',
  'cdn.verify.slide': 'Slide Verify',
  'cdn.verify.slideRegion': 'Slide Region Verify',
  'cdn.verify.rotate': 'Rotate Verify',

  // Bandwidth limit
  'cdn.bandwidthLimit.title': 'Bandwidth Limit',
  'cdn.bandwidthLimit.enabled': 'Enable Bandwidth Limit',
  'cdn.bandwidthLimit.rate': 'Rate Limit (Mbps)',

  // CC protection
  'cdn.cc.form.title': 'CC Protection Configuration',
  'cdn.cc.form.verifyPolicy': 'Verify Method',
  'cdn.cc.form.verifyPolicyTip':
    'Verification method when CC protection is triggered',
  'cdn.cc.form.verifyPolicyRequired': 'Please select a verify method',
  'cdn.cc.form.banDuration': 'Ban Duration',
  'cdn.cc.form.banDurationTip':
    'Ban duration after protection is triggered, e.g. 60s, 5m, 1h',
  'cdn.cc.form.banDurationRequired': 'Please enter ban duration',
  'cdn.cc.rules.title': 'CC Protection Rules',
  'cdn.cc.rules.addTitle': 'Add CC Protection Rule',
  'cdn.cc.rules.matchTarget': 'Match Target',
  'cdn.cc.rules.operator': 'Operator',
  'cdn.cc.rules.actionAllow': 'Allow',
  'cdn.cc.rules.actionVerify': 'Verify',
  'cdn.cc.rules.countPeriod': 'Count Period',
  'cdn.cc.rules.threshold': 'Request Threshold',
  'cdn.cc.rules.required.name': 'Please enter rule name',
  'cdn.cc.rules.required.matchTarget': 'Please select match target',
  'cdn.cc.rules.required.operator': 'Please select operator',
  'cdn.cc.rules.required.content': 'Please enter match content',
  'cdn.cc.rules.required.action': 'Please select action',
  'cdn.cc.rules.required.verifyPolicy': 'Please select verify method',
  'cdn.cc.rules.required.banDuration': 'Please enter ban duration',
  'cdn.cc.rules.required.countPeriod': 'Please enter count period',
  'cdn.cc.rules.placeholder.duration': 'e.g. 60s, 5m, 1h',
  'cdn.cc.rules.descPlaceholder': 'Rule description (optional)',
  'cdn.cc.rules.countPeriodTip': 'Count requests within this time window',
  'cdn.cc.rules.thresholdTip': 'Max requests to trigger the rule (1-100000)',
  'cdn.cc.rules.required.threshold': 'Please enter request threshold',
  'cdn.cc.rules.regexTip': 'Regular expression',
  'cdn.cc.rules.regexPlaceholder': 'Enter regular expression',
  'cdn.cc.rules.content.ipPlaceholder':
    'e.g. 1.2.3.4 or 1.2.0.0/16, one per line',
  'cdn.cc.rules.content.ipMsg':
    'Please enter a valid IPv4 address or CIDR, e.g. 1.2.3.4 or 1.2.0.0/16',
  'cdn.cc.rules.content.ipGroupPlaceholder': 'Enter IP group name',
  'cdn.cc.rules.content.uriPlaceholder': 'e.g. /api/v1/, must start with /',
  'cdn.cc.rules.content.uriMsg': 'URI must start with /',
  'cdn.cc.rules.content.fullUriPlaceholder': 'e.g. https://example.com/path',
  'cdn.cc.rules.content.fullUriMsg':
    'Full URI must start with http:// or https://',
  'cdn.cc.rules.content.uriParamPlaceholder': 'e.g. token or token=value',

  // CDN cache
  'cdn.cache.form.title': 'Cache Configuration',
  'cdn.cache.form.defaultExpiry': 'Default Expiry',
  'cdn.cache.form.day': 'Day',
  'cdn.cache.form.hour': 'Hour',
  'cdn.cache.form.minute': 'Minute',
  'cdn.cache.form.second': 'Second',
  'cdn.cache.form.required.duration': 'Please enter duration',
  'cdn.cache.rules.title': 'Cache Rules',
  'cdn.cache.rules.addTitle': 'Add Cache Rule',
  'cdn.cache.rules.type.regex': 'Regex',
  'cdn.cache.rules.type.suffix': 'Suffix',
  'cdn.cache.rules.type.prefix': 'Prefix',
  'cdn.cache.rules.type.exact': 'Exact',
  'cdn.cache.rules.type.all': 'All',
  'cdn.cache.rules.mode.follow': 'Follow Origin Cache-Control',
  'cdn.cache.rules.mode.force': 'Force Cache',
  'cdn.cache.rules.mode.noCache': 'No Cache',
  'cdn.cache.rules.column.ruleType': 'Rule Type',
  'cdn.cache.rules.column.cacheMode': 'Cache Mode',
  'cdn.cache.rules.column.rangeProxy': 'Range Proxy',
  'cdn.cache.rules.column.cacheTime': 'Cache Time',
  'cdn.cache.rules.required.name': 'Please enter rule name',
  'cdn.cache.rules.required.type': 'Please select rule type',
  'cdn.cache.rules.required.content': 'Please enter match content',
  'cdn.cache.rules.required.mode': 'Please select cache mode',
  'cdn.cache.rules.required.time': 'Please enter cache time',
  'cdn.cache.rules.placeholder.time': 'e.g. 1d, 2h',
  'cdn.cache.rules.placeholder.regex': '^/api/.* (regular expression)',
  'cdn.cache.rules.placeholder.suffix':
    '.jpg,.png,.css (dot-prefixed, comma-separated)',
  'cdn.cache.rules.placeholder.prefix': '/api/v1/ (starts with /)',
  'cdn.cache.rules.placeholder.exact':
    '/index.html (exact path, starts with /)',
  'cdn.cache.rules.validate.regex': 'Please enter a valid regular expression',
  'cdn.cache.rules.validate.suffix':
    'Suffix must start with a dot, e.g. .jpg,.png',
  'cdn.cache.rules.validate.prefix': 'Prefix must start with /',
  'cdn.cache.rules.validate.exact': 'Exact path must start with /',

  // CORS
  'cdn.cors.form.title': 'CORS Configuration',
  'cdn.cors.form.enabled': 'Enable CORS',
  'cdn.cors.form.origins': 'Allowed Origins',
  'cdn.cors.form.originsTip':
    'Press Enter to add origin, e.g. https://example.com',
  'cdn.cors.form.methods': 'Allowed HTTP Methods',
  'cdn.cors.form.methodsPlaceholder': 'Select allowed HTTP methods',
  'cdn.cors.form.headers': 'Allowed Request Headers',
  'cdn.cors.form.headersTip': 'Press Enter to add header, e.g. Content-Type',
  'cdn.cors.form.credentials': 'Allow Credentials',
  'cdn.cors.form.exposeHeaders': 'Exposed Response Headers',
  'cdn.cors.form.exposeHeadersTip': 'Press Enter to add header',
  'cdn.cors.form.maxAge': 'Preflight Cache Duration',
  'cdn.cors.form.maxAgeTip': 'Seconds to cache OPTIONS preflight response',

  // Domain management
  'cdn.domain.table.title': 'Domain Management',
  'cdn.domain.table.addDomain': 'Add Domain',
  'cdn.domain.table.column.domain': 'Domain',
  'cdn.domain.table.column.primary': 'Primary',
  'cdn.domain.table.column.verifyStatus': 'Verify Status',
  'cdn.domain.table.column.icpStatus': 'ICP Status',
  'cdn.domain.table.verified': 'Verified',
  'cdn.domain.table.unverified': 'Unverified',
  'cdn.domain.table.unset': 'Unset',
  'cdn.domain.table.setPrimary': 'Set as Primary',
  'cdn.domain.table.verify': 'Verify',
  'cdn.domain.table.verifyIcp': 'Verify ICP',
  'cdn.domain.table.deleteConfirm':
    'Are you sure you want to delete this domain?',
  'cdn.domain.table.lastDomainDeleteBlocked':
    'A site must retain at least one domain. Please add another domain first',
  'cdn.domain.table.setPrimarySuccess': 'Set {domain} as primary domain',
  'cdn.domain.table.setPrimaryFailed': 'Failed to set primary domain',
  'cdn.domain.table.icpVerifySuccess': 'ICP verification successful: {status}',
  'cdn.domain.table.icpVerifyFailed': 'ICP verification failed',
  'cdn.domain.table.verifyFailed': 'Verification failed',
  'cdn.domain.table.addSuccess': 'Domain added, please verify before enabling',
  'cdn.domain.table.addFailed': 'Add failed',
  'cdn.domain.table.domainPlaceholder': 'e.g. example.com',

  // Geo control
  'cdn.geo.form.title': 'Geo Control Configuration',
  'cdn.geo.form.unknownRegion': 'Unknown Region Handling',
  'cdn.geo.form.unknownRegionTip':
    'Default action for regions not matching any rule',
  'cdn.geo.form.required.action': 'Please select an action',
  'cdn.geo.rules.title': 'Geo Control Rules',
  'cdn.geo.rules.addTitle': 'Add Geo Control Rule',
  'cdn.geo.rules.column.region': 'Region',
  'cdn.geo.rules.required.region': 'Please select a region',
  'cdn.geo.rules.required.action': 'Please select an action',
  'cdn.geo.rules.required.redirectUrl': 'Please enter redirect URL',
  'cdn.geo.rules.placeholder.redirectUrl': 'https://example.com',
  'cdn.geo.country.cn': 'China (CN)',
  'cdn.geo.country.us': 'United States (US)',
  'cdn.geo.country.jp': 'Japan (JP)',
  'cdn.geo.country.kr': 'South Korea (KR)',
  'cdn.geo.country.gb': 'United Kingdom (GB)',
  'cdn.geo.country.de': 'Germany (DE)',
  'cdn.geo.country.fr': 'France (FR)',
  'cdn.geo.country.ru': 'Russia (RU)',
  'cdn.geo.country.br': 'Brazil (BR)',
  'cdn.geo.country.in': 'India (IN)',
  'cdn.geo.country.au': 'Australia (AU)',
  'cdn.geo.country.ca': 'Canada (CA)',
  'cdn.geo.country.sg': 'Singapore (SG)',
  'cdn.geo.country.hk': 'Hong Kong (HK)',
  'cdn.geo.country.tw': 'Taiwan (TW)',

  // Gzip compression
  'cdn.gzip.form.title': 'Compression Configuration',
  'cdn.gzip.form.enabled': 'Enable Gzip',
  'cdn.gzip.form.level': 'Compression Level',
  'cdn.gzip.form.levelTip':
    'Range 1-9; higher level means better compression but more CPU; recommended: 6',
  'cdn.gzip.form.levelExtra':
    'Range: 1 (fastest) - 9 (best compression), recommended: 6',
  'cdn.gzip.form.minSize': 'Min Compression Size (bytes)',

  // Custom Header
  'cdn.header.table.title': 'Custom Headers',
  'cdn.header.table.addTitle': 'Add Header',
  'cdn.header.table.editTitle': 'Edit Header',
  'cdn.header.table.column.headerType': 'Header Type',
  'cdn.header.table.column.headerName': 'Header Name',
  'cdn.header.table.column.value': 'Value',
  'cdn.header.table.column.action': 'Action',
  'cdn.header.table.column.matchRegex': 'Match Regex',
  'cdn.header.table.column.replace': 'Replacement',
  'cdn.header.table.type.request': 'Request Header',
  'cdn.header.table.type.response': 'Response Header',
  'cdn.header.table.action.set': 'Set',
  'cdn.header.table.action.append': 'Append',
  'cdn.header.table.action.delete': 'Delete',
  'cdn.header.table.action.rewrite': 'Rewrite',
  'cdn.header.table.deleteConfirm':
    'Are you sure you want to delete this header?',
  'cdn.header.table.required.type': 'Please select header type',
  'cdn.header.table.required.name': 'Please enter header name',
  'cdn.header.table.required.action': 'Please select action',
  'cdn.header.table.required.regex': 'Please enter match regex',
  'cdn.header.table.required.replace': 'Please enter replacement',
  'cdn.header.table.placeholder.name': 'e.g. X-Custom-Header',
  'cdn.header.table.placeholder.value': 'Enter header value',
  'cdn.header.table.placeholder.regex': 'Regular expression, e.g. ^(.*)$',
  'cdn.header.table.placeholder.replace': 'Replacement, e.g. $1-suffix',

  // HTTPS configuration
  'cdn.https.form.title': 'HTTPS Configuration',
  'cdn.https.form.enabled': 'Enable HTTPS',
  'cdn.https.form.autoSsl': 'Auto-issue Certificate',
  'cdn.https.form.autoSslTip':
    'When enabled, the system will automatically request a TLS certificate via ACME; no need to fill in certificate content manually',
  'cdn.https.form.forceRedirect': 'Force HTTP to HTTPS Redirect',
  'cdn.https.form.certPem': 'Certificate (Public Key)',
  'cdn.https.form.certPemTip': 'Not required when auto-issuing certificate',
  'cdn.https.form.certPemPlaceholder':
    'Paste PEM certificate content (-----BEGIN CERTIFICATE-----)',
  'cdn.https.form.keyPem': 'Private Key',
  'cdn.https.form.keyPemPlaceholder':
    'Paste PEM private key content (-----BEGIN PRIVATE KEY-----)',

  // Human verification
  'cdn.human.form.title': 'Human Verification Configuration',
  'cdn.human.form.verifyAll': 'Verify All Requests',
  'cdn.human.form.verifyAllTip':
    'When enabled, all requests require human verification, ignoring rule matching',
  'cdn.human.form.verifyPolicy': 'Verify Method',
  'cdn.human.form.verifyPolicyRequired': 'Please select verify method',
  'cdn.human.form.verifyPeriod': 'Verification Validity',
  'cdn.human.form.verifyPeriodTip':
    'Validity period after passing verification, e.g. 60s, 5m, 1h',
  'cdn.human.form.verifyPeriodPlaceholder': 'e.g. 60s',
  'cdn.human.form.verifyPeriodRequired': 'Please enter validity period',
  'cdn.human.rules.title': 'Verification Rules',
  'cdn.human.rules.addTitle': 'Add Human Verification Rule',
  'cdn.human.rules.column.matchMode': 'Match Mode',
  'cdn.human.rules.column.operator': 'Operator',
  'cdn.human.rules.column.period': 'Validity',
  'cdn.human.rules.required.name': 'Please enter rule name',
  'cdn.human.rules.required.matchMode': 'Please select match mode',
  'cdn.human.rules.required.operator': 'Please select operator',
  'cdn.human.rules.placeholder.content': 'Multiple values separated by |',
  'cdn.human.rules.required.content': 'Please enter match content',
  'cdn.human.rules.required.verifyPolicy': 'Please select verify method',
  'cdn.human.rules.required.verifyPeriod': 'Please enter validity period',

  // IP access control
  'cdn.ipAccess.form.title': 'IP Access Control Configuration',
  'cdn.ipAccess.form.defaultAction': 'Default Action',
  'cdn.ipAccess.form.required.action': 'Please select default action',
  'cdn.ipAccess.rules.title': 'IP Rules',
  'cdn.ipAccess.rules.addTitle': 'Add IP Access Control Rule',
  'cdn.ipAccess.rules.column.ip': 'IP',
  'cdn.ipAccess.rules.column.policy': 'Access Policy',
  'cdn.ipAccess.rules.placeholder.ip': 'e.g. 192.168.1.1 or 192.168.1.0/24',
  'cdn.ipAccess.rules.required.ip': 'Please enter IP address',
  'cdn.ipAccess.rules.required.policy': 'Please select access policy',

  // Language control
  'cdn.language.form.title': 'Language Control Configuration',
  'cdn.language.form.defaultLanguage': 'Default Language',
  'cdn.language.form.defaultLanguagePlaceholder': 'e.g. zh-CN',
  'cdn.language.form.autoDetect': 'Auto Detect Language',
  'cdn.language.form.required.language': 'Please enter default language',
  'cdn.language.rules.title': 'Language Rules',
  'cdn.language.rules.addTitle': 'Add Language Rule',
  'cdn.language.rules.column.languages': 'Language List',
  'cdn.language.rules.placeholder.languages':
    'Comma-separated languages, e.g. zh-CN, en-US',
  'cdn.language.rules.required.languages': 'Please enter language code',
  'cdn.language.rules.required.action': 'Please select action',
  'cdn.language.rules.placeholder.redirectUrl': 'e.g. https://example.com/',
  'cdn.language.rules.required.redirectUrl': 'Please enter redirect URL',

  // Referer hotlink protection
  'cdn.referer.form.title': 'Hotlink Protection Configuration',
  'cdn.referer.form.stripQuery': 'Strip Query String',
  'cdn.referer.form.stripQueryTip':
    'Whether to ignore query parameters when computing hotlink protection',
  'cdn.referer.rules.title': 'Hotlink Protection Rules',
  'cdn.referer.rules.addTitle': 'Add Hotlink Protection Rule',
  'cdn.referer.rules.column.url': 'URL',

  'cdn.referer.rules.required.url': 'Please enter URL',

  // Site detail
  'cdn.site.title': 'Site Details',
  'cdn.site.status': 'Status: ',
  'cdn.site.changeStatus': 'Change Status',
  'cdn.site.fetchFailed': 'Failed to fetch site details: ',
  'cdn.site.notFound': 'Site not found',
  'cdn.site.statusModal.title': 'Change Site Status',
  'cdn.site.statusModal.currentStatus': 'Current Status: ',
  'cdn.site.statusModal.selectNew': 'Select New Status: ',
  'cdn.site.statusModal.onlineNote':
    'Pre-online requirements: at least one verified domain, complete origin configuration, complete line configuration',
  'cdn.site.statusModal.noChange': 'Status unchanged',
  'cdn.site.statusModal.updateSuccess': 'Status updated successfully',
  'cdn.site.statusModal.updateFailed': 'Status update failed',
  'cdn.site.statusModal.confirm': 'Confirm',

  // Load balancing
  'cdn.upstream.form.title': 'Load Balancing Configuration',
  'cdn.upstream.form.strategy': 'Load Balancing Strategy',
  'cdn.upstream.form.strategy.random': 'Random',
  'cdn.upstream.form.strategy.roundRobin': 'Round Robin',
  'cdn.upstream.form.strategy.leastConn': 'Least Connections',
  'cdn.upstream.form.strategy.ipHash': 'IP Hash',
  'cdn.upstream.form.strategy.weightedRR': 'Weighted Round Robin',
  'cdn.upstream.form.required.strategy':
    'Please select load balancing strategy',
  'cdn.upstream.servers.title': 'Origin Server List',
  'cdn.upstream.servers.column.address': 'Address',
  'cdn.upstream.servers.column.port': 'Port',
  'cdn.upstream.servers.column.weight': 'Weight',
  'cdn.upstream.servers.column.https': 'HTTPS',
  'cdn.upstream.servers.column.protocol': 'Protocol',
  'cdn.upstream.servers.column.note': 'Note',
  'cdn.upstream.servers.deleteConfirm':
    'Are you sure you want to delete this server?',
  'cdn.upstream.servers.mtls.title': 'Client Certificate (Optional)',
  'cdn.upstream.servers.mtls.description':
    'The following key pair is for mutual TLS (mTLS): fill in when the upstream server requires client identity verification. Not required for regular HTTPS origin; leave blank. Both public and private keys must be provided together or left blank together.',
  'cdn.upstream.servers.mtls.privateKey': 'Client Private Key',
  'cdn.upstream.servers.mtls.privateKeyPlaceholder':
    'Optional, for mTLS. Paste private key content (PEM format, starting with -----BEGIN ... KEY-----)',
  'cdn.upstream.servers.mtls.privateKeyTip':
    'mTLS client private key, not required for regular HTTPS origin',

  // URL access control
  'cdn.urlAccess.form.title': 'URL Access Control Configuration',
  'cdn.urlAccess.form.defaultAction': 'Default Action',
  'cdn.urlAccess.form.required.action': 'Please select default action',
  'cdn.urlAccess.rules.title': 'URL Access Rules',
  'cdn.urlAccess.rules.addTitle': 'Add URL Access Control Rule',
  'cdn.urlAccess.rules.column.operator': 'Operator',
  'cdn.urlAccess.rules.op.exactMatch': 'Exact Match',
  'cdn.urlAccess.rules.op.prefixMatch': 'Prefix Match',
  'cdn.urlAccess.rules.op.suffixMatch': 'Suffix Match',
  'cdn.urlAccess.rules.op.contains': 'Contains',
  'cdn.urlAccess.rules.op.regexMatch': 'Regex Match',
  'cdn.urlAccess.rules.action.allow': 'Allow',
  'cdn.urlAccess.rules.required.name': 'Please enter rule name',
  'cdn.urlAccess.rules.required.operator': 'Please select operator',
  'cdn.urlAccess.rules.placeholder.content': 'Enter URL match content',
  'cdn.urlAccess.rules.required.content': 'Please enter match content',
  'cdn.urlAccess.rules.required.action': 'Please select action',
  'cdn.urlAccess.rules.placeholder.redirectUrl':
    'e.g. https://example.com/new-path',
  'cdn.urlAccess.rules.required.redirectUrl': 'Please enter redirect URL',

  // URL Authentication
  'cdn.urlAuth.form.title': 'URL Authentication Configuration',
  'cdn.urlAuth.form.statusTip': 'Enable or disable URL authentication',
  'cdn.urlAuth.info.title': 'Authentication Parameters',
  'cdn.urlAuth.info.siteId': 'Site ID',
  'cdn.urlAuth.info.domains': 'Available Domains',
  'cdn.urlAuth.info.signatureBase': 'Signature Base Format',
  'cdn.urlAuth.info.urlParams': 'URL Parameters',
  'cdn.urlAuth.info.param.expires': 'Expiration time (Unix timestamp)',
  'cdn.urlAuth.info.param.key': 'Key ID',
  'cdn.urlAuth.info.param.signature': 'Signature (Hex encoded)',
  'cdn.urlAuth.keys.title': 'Authentication Keys',
  'cdn.urlAuth.keys.generateKey': 'Generate Key',
  'cdn.urlAuth.keys.modal.title': 'Generate Authentication Key',
  'cdn.urlAuth.keys.form.algorithm': 'Algorithm',
  'cdn.urlAuth.keys.required.algorithm': 'Please select algorithm',
  'cdn.urlAuth.keys.createSuccess': 'Key generated successfully',
  'cdn.urlAuth.keys.deleteConfirm':
    'Are you sure you want to delete this key? It cannot be recovered.',
  'cdn.urlAuth.keys.column.keyId': 'Key ID',
  'cdn.urlAuth.keys.column.algorithm': 'Algorithm',
  'cdn.urlAuth.keys.result.title': 'Key Generated - Save Immediately',
  'cdn.urlAuth.keys.result.warning':
    'The private key is shown only once and cannot be viewed again after closing!',
  'cdn.urlAuth.keys.result.keyId': 'Key ID',
  'cdn.urlAuth.keys.result.algorithm': 'Algorithm',
  'cdn.urlAuth.keys.result.privateKey': 'Private Key',
  'cdn.urlAuth.keys.result.saved': 'I have saved it',
  'cdn.urlAuth.rules.title': 'Authentication Rules',
  'cdn.urlAuth.rules.action.auth': 'Authentication Required',
  'cdn.urlAuth.rules.action.pass': 'No Authentication',
  'cdn.urlAuth.rules.modal.title': 'Add Authentication Rule',
  'cdn.urlAuth.rules.editTitle': 'Edit Authentication Rule',
  'cdn.urlAuth.rules.form.contentPlaceholder':
    'Enter URL path, e.g. /video/ or /api/*',
  'cdn.urlAuth.rules.form.actionTip':
    'Authentication Required: matching URLs need signature parameters; No Authentication: matching URLs can be accessed without signature',
  'cdn.urlAuth.rules.required.name': 'Please enter rule name',
  'cdn.urlAuth.rules.required.operator': 'Please select operator',
  'cdn.urlAuth.rules.required.content': 'Please enter match content',
  'cdn.urlAuth.rules.required.action': 'Please select action',

  // URL Auth Instructions
  'cdn.urlAuth.instructions.title': 'URL Authentication Guide',
  'cdn.urlAuth.instructions.principle': 'Authentication Principle',
  'cdn.urlAuth.instructions.principle.desc':
    'URL authentication protects CDN resources through digital signatures, preventing unauthorized access.',
  'cdn.urlAuth.instructions.principle.item1':
    'Content providers sign URLs using a private key',
  'cdn.urlAuth.instructions.principle.item2':
    'CDN edge nodes verify signature validity using the public key',
  'cdn.urlAuth.instructions.principle.item3':
    'After verification, authentication parameters are stripped, not affecting cache hit rate',
  'cdn.urlAuth.instructions.principle.item4':
    'Supports Ed25519 (recommended) and HMAC-SHA256 algorithms',
  'cdn.urlAuth.instructions.flow': 'Signing Process',
  'cdn.urlAuth.instructions.flow.step1':
    'Construct signature message: site_id|host|path|expires',
  'cdn.urlAuth.instructions.flow.step2':
    'Sign the message using the private key',
  'cdn.urlAuth.instructions.flow.step3': 'Hex encode the signature',
  'cdn.urlAuth.instructions.flow.step4':
    'Append signature parameters to the URL',
  'cdn.urlAuth.instructions.urlFormat': 'URL Format',
  'cdn.urlAuth.instructions.paramExpires': 'x-cdn-auth-expires',
  'cdn.urlAuth.instructions.paramExpires.desc':
    'Expiration time, Unix timestamp (seconds)',
  'cdn.urlAuth.instructions.paramKey': 'x-cdn-auth-key',
  'cdn.urlAuth.instructions.paramKey.desc':
    'Key ID, which is the record_id of the key',
  'cdn.urlAuth.instructions.paramSig': 'x-cdn-auth-signature',
  'cdn.urlAuth.instructions.paramSig.desc': 'Hex encoded signature',
  'cdn.urlAuth.instructions.codeExamples': 'Code Examples',
  'cdn.urlAuth.instructions.codeExamples.desc':
    'Below are complete code examples in various languages for generating signed URLs. You can copy and use them directly.',
  'cdn.urlAuth.instructions.codeExamples.tip':
    'If your programming language is not listed above, you can refer to the code logic and let AI help you generate the implementation for your language.',

  // URL rewrite
  'cdn.urlRewrite.form.title': 'URL Rewrite Configuration',
  'cdn.urlRewrite.form.description':
    'URL rewrite is controlled by the switch in the top-right corner. Manage rewrite rules in the "Rules" tab.',
  'cdn.urlRewrite.rules.title': 'Rewrite Rules',
  'cdn.urlRewrite.rules.addTitle': 'Add URL Rewrite Rule',
  'cdn.urlRewrite.rules.column.pattern': 'Pattern',
  'cdn.urlRewrite.rules.column.replacement': 'Replacement',
  'cdn.urlRewrite.rules.placeholder.pattern': 'e.g. ^/old/(.*)$',
  'cdn.urlRewrite.rules.required.pattern': 'Please enter pattern',
  'cdn.urlRewrite.rules.placeholder.replacement': 'e.g. /new/$1',
  'cdn.urlRewrite.rules.required.replacement': 'Please enter replacement',

  // User Agent control
  'cdn.ua.form.title': 'UA Control Configuration',
  'cdn.ua.form.unknownUa': 'Unknown UA Handling',
  'cdn.ua.form.unknownUaTip':
    'Default action for User-Agents not matching any rule',
  'cdn.ua.form.action.allowDefault': 'Allow (Default)',
  'cdn.ua.form.required.action': 'Please select handling method',
  'cdn.ua.rules.title': 'UA Control Rules',
  'cdn.ua.rules.addTitle': 'Add UA Control Rule',
  'cdn.ua.rules.column.ua': 'User-Agent',
  'cdn.ua.rules.action.allow': 'Allow',
  'cdn.ua.rules.action.allowNote': 'Allow Access',
  'cdn.ua.rules.placeholder.ua': 'e.g. Mozilla/5.0 or keyword fragment',
  'cdn.ua.rules.required.ua': 'Please enter User-Agent',
  'cdn.ua.rules.required.action': 'Please select action',
  'cdn.ua.rules.placeholder.redirectUrl': 'https://example.com',
  'cdn.ua.rules.required.redirectUrl': 'Please enter redirect URL',

  // WAF
  'cdn.waf.form.title': 'WAF Protection Configuration',

  // DNS
  'cdn.dns.title': 'DNS Records',
  'cdn.dns.providerPlaceholder': 'DNS Provider (optional)',
  'cdn.dns.column.name': 'Record Name',
  'cdn.dns.column.type': 'Record Type',
  'cdn.dns.column.value': 'Record Value',
  'cdn.dns.column.ttl': 'TTL',
  'cdn.dns.column.priority': 'Priority',

  // Line management
  'cdn.line.title': 'Line Management',
  'cdn.line.createTitle': 'Create Line',
  'cdn.line.editTitle': 'Edit Line',
  'cdn.line.createButton': 'Create Line',
  'cdn.line.required.name': 'Please enter line name',
  'cdn.line.deleteConfirm': 'Are you sure you want to delete this line?',

  // Monitoring
  'cdn.monitor.traffic': 'Traffic Statistics',
  'cdn.monitor.totalTraffic': 'Total Traffic',
  'cdn.monitor.currentBandwidth': 'Current Bandwidth',
  'cdn.monitor.bandwidthUnit': '/s',
  'cdn.monitor.peakBandwidth': 'Peak Bandwidth',
  'cdn.monitor.requests': 'Request Statistics',
  'cdn.monitor.totalRequests': 'Total Requests',
  'cdn.monitor.currentQps': 'Current QPS',
  'cdn.monitor.qpsUnit': 'req/s',
  'cdn.monitor.peakQps': 'Peak QPS',

  // Node management
  'cdn.node.title': 'Node Management',
  'cdn.node.list.title': 'Node List',
  'cdn.node.column.deviceCode': 'Device Code',
  'cdn.node.column.version': 'Version',
  'cdn.node.column.region': 'Region',
  'cdn.node.column.healthStatus': 'Health Status',
  'cdn.node.column.status': 'Status',
  'cdn.node.column.ip': 'IP Address',
  'cdn.node.column.lines': 'Associated Lines',
  'cdn.node.column.expiredAt': 'Expiration Time',
  'cdn.node.column.hostname': 'Hostname',
  'cdn.node.column.updatedAt': 'Updated At',
  'cdn.node.status.online': 'Online',
  'cdn.node.status.offline': 'Offline',
  'cdn.node.status.pending': 'Pending',
  'cdn.node.status.upgrading': 'Upgrading',
  'cdn.node.status.migrating': 'Migrating',
  'cdn.node.status.trafficOverLimit': 'Traffic Over Limit',
  'cdn.node.status.expired': 'Expired',
  'cdn.node.health.healthy': 'Healthy',
  'cdn.node.health.unhealthy': 'Unhealthy',
  'cdn.node.health.unknown': 'Unknown',
  'cdn.node.health.unregister': 'Unregistered',
  'cdn.node.updateStatus': 'Update Status',
  'cdn.node.updateExpiredAt': 'Update Expiration Time',
  'cdn.node.deleteConfirm': 'Are you sure you want to delete this node?',
  'cdn.node.modal.title': 'Update Node Status',
  'cdn.node.modal.deviceCode': 'Device Code',
  'cdn.node.modal.required.status': 'Please select status',
  'cdn.node.modal.updateSuccess': 'Status updated successfully',
  'cdn.node.modal.updateFailed': 'Failed to update status',

  // Node IP management
  'cdn.nodeIp.title': 'Node IP Management',
  'cdn.nodeIp.addButton': 'Add IP',
  'cdn.nodeIp.createTitle': 'Add IP',
  'cdn.nodeIp.editDnsLineTitle': 'Edit DNS Line',
  'cdn.nodeIp.editDnsLine': 'Edit Line',
  'cdn.nodeIp.column.ip': 'IP',
  'cdn.nodeIp.column.ipType': 'Type',
  'cdn.nodeIp.column.dnsLine': 'DNS Line',
  'cdn.nodeIp.column.createdAt': 'Created At',
  'cdn.nodeIp.form.ipType': 'Type',
  'cdn.nodeIp.form.ip': 'IP',
  'cdn.nodeIp.form.dnsLine': 'DNS Line',
  'cdn.nodeIp.form.required.ipType': 'Please select type',
  'cdn.nodeIp.form.required.ip': 'Please enter IP',
  'cdn.nodeIp.form.required.dnsLine': 'Please select DNS line',
  'cdn.nodeIp.form.placeholder.ip': 'Enter IP',
  'cdn.nodeIp.form.invalid.ipv4': 'Invalid IPv4 format',
  'cdn.nodeIp.form.invalid.ipv6': 'Invalid IPv6 format',
  'cdn.nodeIp.createSuccess': 'Added successfully',
  'cdn.nodeIp.createFailed': 'Failed to add',
  'cdn.nodeIp.updateDnsLineSuccess': 'DNS line updated successfully',
  'cdn.nodeIp.updateDnsLineFailed': 'Failed to update DNS line',
  'cdn.nodeIp.updateStatusSuccess': 'Status updated successfully',
  'cdn.nodeIp.updateStatusFailed': 'Failed to update status',
  'cdn.nodeIp.deleteConfirm': 'Are you sure you want to delete this IP?',
  'cdn.nodeIp.loadFailed': 'Failed to load',
  'cdn.nodeIp.syncWarning':
    'Manually added/modified IPs may be automatically overwritten when the node registers next time',
  'cdn.nodeIp.selectNode': 'Select Node',
  'cdn.nodeIp.noNodeSelected': 'No node selected',
  'cdn.node.tab.ips': 'IP Management',
  'cdn.node.tab.desc.ips':
    'Manage node IP addresses, including adding, editing, and deleting IPv4 and IPv6 addresses.',

  // Node default config
  'cdn.node.defaultConfig.title': 'Node Default Configuration',
  'cdn.node.defaultConfig.button': 'Global Default Config',

  // Site list & creation
  'cdn.site.list.title': 'Site Management',
  'cdn.site.list.createButton': 'Create Site',
  'cdn.site.list.column.site': 'Site',
  'cdn.site.list.column.accessType': 'Access Type',
  'cdn.site.list.column.region': 'Region',
  'cdn.site.list.column.tags': 'Tags',
  'cdn.site.list.column.updatedAt': 'Updated At',
  'cdn.site.list.column.subscriptionType': 'Subscription Type',
  'cdn.site.list.deleteConfirm': 'Are you sure you want to delete this site?',
  'cdn.site.create.basicInfo': 'Basic Information',
  'cdn.site.create.domain': 'Domain',
  'cdn.site.create.domainPlaceholder': 'Enter site domain, e.g. example.com',
  'cdn.site.create.domainRequired': 'Please enter domain',
  'cdn.site.create.domainInvalid': 'Please enter a valid domain format',
  'cdn.site.create.siteName': 'Site Name',
  'cdn.site.create.siteNamePlaceholder': 'Enter site name (optional)',
  'cdn.site.create.regionTitle': 'Region & Access',
  'cdn.site.create.selectRegion': 'Select Acceleration Region',
  'cdn.site.create.accessNote':
    'Access type: CNAME (add a CNAME record pointing to the CDN-provided domain)',
  'cdn.site.create.selectPlan': 'Select Plan',
  'cdn.site.create.selectPlanTitle': 'Select Service Plan',
  'cdn.site.create.success': 'Site created successfully',
  'cdn.site.create.failed': 'Create failed',

  // Site detail tabs
  'cdn.site.tab.domains': 'Domains',
  'cdn.site.tab.upstream': 'Origin',
  'cdn.site.tab.https': 'SSL/TLS',
  'cdn.site.tab.cdn': 'Cache Rules',
  'cdn.site.tab.cc': 'CC Protection',
  'cdn.site.tab.waf': 'WAF',
  'cdn.site.tab.geo': 'Geo Restriction',
  'cdn.site.tab.human': 'Bot Management',
  'cdn.site.tab.gzip': 'Content Compression',
  'cdn.site.tab.cors': 'CORS',
  'cdn.site.tab.referer': 'Hotlink Protection',
  'cdn.site.tab.ua': 'UA Filter',
  'cdn.site.tab.ipAccess': 'IP Allowlist/Blocklist',
  'cdn.site.tab.urlAccess': 'URL Filter',
  'cdn.site.tab.urlAuth': 'URL Authentication',
  'cdn.site.tab.urlRewrite': 'URL Rewrite',
  'cdn.site.tab.headers': 'Header Management',
  'cdn.site.tab.language': 'Language Restriction',
  'cdn.site.tab.bandwidthLimit': 'Bandwidth Throttling',

  // Site detail sidebar navigation
  'cdn.site.sideMenu.backToList': 'Back to Site List',
  'cdn.site.sideMenu.group.basic': 'Site Config',
  'cdn.site.sideMenu.group.performance': 'Cache & Performance',
  'cdn.site.sideMenu.group.security': 'Security',
  'cdn.site.sideMenu.group.access': 'Access Control',
  'cdn.site.sideMenu.group.advanced': 'Advanced',
  'cdn.site.tab.config': 'Config',
  'cdn.site.tab.rules': 'Rules',
  'cdn.site.tab.servers': 'Servers',

  // Tab descriptions
  'cdn.site.tab.desc.domains':
    'Manage domains bound to this site, including adding, removing, and DNS verification of primary and backup domains.',
  'cdn.site.tab.desc.upstream':
    'Configure origin server addresses, weights, and connection parameters with support for multi-origin load balancing and health checks.',
  'cdn.site.tab.desc.https':
    'Configure SSL/TLS certificate binding, force HTTPS redirect, HSTS, and TLS protocol version settings.',
  'cdn.site.tab.desc.cdn':
    'Control edge node caching policies including global TTL, cache modes, and custom cache rules by path or file suffix.',
  'cdn.site.tab.desc.cc':
    'CC (Challenge Collapsar) Protection: Limit request frequency via global config and custom rules by IP, URI, or Header dimensions. Triggers blocking or CAPTCHA when threshold is exceeded.',
  'cdn.site.tab.desc.waf':
    'Web Application Firewall: Detect and block SQL injection, XSS, command injection, and other common web attacks.',
  'cdn.site.tab.desc.geo':
    'Control access based on visitor geographic location (country/region) using allowlists or blocklists.',
  'cdn.site.tab.desc.human':
    'Distinguish real users from automated bots via behavioral analysis. Triggers slider or image CAPTCHA challenges for suspicious traffic.',
  'cdn.site.tab.desc.gzip':
    'Enable Gzip/Brotli response compression to reduce transfer size, improve page load speed, and lower bandwidth usage.',
  'cdn.site.tab.desc.cors':
    'Configure Cross-Origin Resource Sharing (CORS) policies to control which origin domains can access site resources via browsers.',
  'cdn.site.tab.desc.referer':
    'Restrict resource access based on HTTP Referer header to prevent other sites from hotlinking images, videos, and static resources.',
  'cdn.site.tab.desc.ua':
    'Filter based on client User-Agent to block specific crawlers, scanning tools, or malicious clients.',
  'cdn.site.tab.desc.ipAccess':
    'IP-based access control supporting exact IPs and CIDR ranges in allowlists and blocklists.',
  'cdn.site.tab.desc.urlAccess':
    'URL path-based access control to allow or deny access to specific paths or path patterns.',
  'cdn.site.tab.desc.urlAuth':
    'Protect resources through signature verification to prevent unauthorized access. Supports Ed25519 and HMAC-SHA256 algorithms.',
  'cdn.site.tab.desc.urlRewrite':
    'Perform 301/302 redirects or internal path rewrites on request URLs, supporting regex matching and capture group substitution.',
  'cdn.site.tab.desc.headers':
    'Add, modify, or remove HTTP response/request headers including security headers and cache directives.',
  'cdn.site.tab.desc.language':
    'Filter access based on Accept-Language header to allow or deny specific language/region users.',
  'cdn.site.tab.desc.bandwidthLimit':
    'Limit per-connection or site-wide downstream bandwidth to prevent abuse and control traffic consumption rate.',

  // Site node IP whitelist
  'cdn.site.nodeIps.fetchError': 'Failed to fetch node IP list',
  'cdn.site.nodeIps.title': 'CDN Origin IP Whitelist',
  'cdn.site.nodeIps.desc':
    'If your server has a firewall enabled, you need to add the following CDN node IPs to the firewall whitelist, otherwise CDN cannot origin properly.',
  'cdn.site.nodeIps.hint':
    'If your server does not have a firewall enabled, you can ignore this configuration.',
  'cdn.site.nodeIps.steps.title': 'Steps:',
  'cdn.site.nodeIps.steps.1': 'Click "Copy All" button to copy IP addresses',
  'cdn.site.nodeIps.copyAll': 'Copy All',
  'cdn.site.nodeIps.steps.2': 'Log in to your server management panel',
  'cdn.site.nodeIps.steps.3':
    'In firewall/security group rules, add these IPs as "Allow"',
  'cdn.site.nodeIps.steps.4': 'Save configuration',
  'cdn.site.nodeIps.emptyIpv4': 'No IPv4 data',
  'cdn.site.nodeIps.emptyIpv6': 'No IPv6 data',

  // Node status updates
  'cdn.node.updateStatusSuccess': 'Status updated successfully',
  'cdn.node.updateStatusFailed': 'Failed to update status',

  // Site list supplement
  'cdn.site.list.viewDetail': 'View Detail',

  // Site create supplement
  'cdn.site.create.button': 'Create Site',
  'cdn.site.create.step.basic': 'Basic Info',
  'cdn.site.create.step.region': 'Region & Access',
  'cdn.site.create.step.plan': 'Select Plan',
  'cdn.site.create.label.domain': 'Domain',
  'cdn.site.create.label.name': 'Site Name',
  'cdn.site.create.placeholder.domain': 'Enter site domain, e.g. example.com',
  'cdn.site.create.placeholder.name': 'Enter site name (optional)',
  'cdn.site.create.required.domain': 'Please enter a domain',
  'cdn.site.create.required.domainFormat': 'Please enter a valid domain format',
  'cdn.site.create.cnameHint':
    'Access type: CNAME (add a CNAME record pointing to the CDN-provided domain)',

  // Monitor supplement
  'cdn.monitor.request': 'Request Stats',
  'cdn.monitor.title': 'Monitoring',
  'cdn.monitor.qpsSuffix': 'req/s',

  // Line supplement
  'cdn.line.column.createdAt': 'Created At',

  // Site status modal
  'cdn.site.statusModal.selectStatus': 'Select New Status: ',
  'cdn.site.statusModal.activateWarning':
    'Before going live: at least one verified domain, upstream configured, and line configured',

  // Gzip form
  'cdn.gzip.form.enableGzip': 'Enable Gzip',
  'cdn.gzip.form.levelTooltip':
    'Range 1-9; higher level = better compression but more CPU; recommended: 6',
  'cdn.gzip.form.minLength': 'Minimum Size to Compress (bytes)',

  // Human verification form
  'cdn.human.form.expiry': 'Verification Expiry',
  'cdn.human.form.expiryPlaceholder': 'e.g. 60s',

  // Upstream load balancing form
  'cdn.upstream.form.lbTitle': 'Load Balancing Settings',
  'cdn.upstream.form.lbStrategy': 'Load Balancing Strategy',
  'cdn.upstream.form.lbRandom': 'Random',
  'cdn.upstream.form.lbRoundRobin': 'Round Robin',

  // URL access control form

  // IP access control form

  // UA control form

  // Referer form

  // Language form

  // WAF form

  // URL rewrite form

  // CORS form

  // Match options supplement

  // Site tab layout
  'cdn.site.tabLayout.notFound': 'Site Not Found',
  'cdn.site.tabLayout.title': 'Site Detail',
  'cdn.site.tabLayout.changeStatus': 'Change Status',
  'cdn.common.statusLabel': 'Status: ',
  'cdn.status.active': 'Active',
  'cdn.status.inactive': 'Inactive',
  'cdn.status.pending': 'Pending',
  'cdn.status.suspended': 'Suspended',
  'cdn.status.arrears': 'Arrears',
  'cdn.status.transferred': 'Transferred',

  // Upstream servers
  'cdn.upstream.servers.serverSuffix': ' server(s)',

  // Domain table
  'cdn.domain.table.setPrimarySuccessEnd': 'set as primary domain',

  // Domain verification modal
  'cdn.domain.verify.recordType': 'Record Type',
  'cdn.domain.verify.hostRecord': 'Host Record',
  'cdn.domain.verify.recordValue': 'Record Value',
  'cdn.domain.verify.copyTooltip': 'Copy configuration',

  // Header action types
  'cdn.header.table.action.add': 'Add',
  'cdn.header.table.action.del': 'Delete',

  // Geo countries
  'cdn.geo.country.CN': 'China (CN)',
  'cdn.geo.country.US': 'United States (US)',
  'cdn.geo.country.JP': 'Japan (JP)',
  'cdn.geo.country.KR': 'South Korea (KR)',
  'cdn.geo.country.GB': 'United Kingdom (GB)',
  'cdn.geo.country.DE': 'Germany (DE)',
  'cdn.geo.country.FR': 'France (FR)',
  'cdn.geo.country.RU': 'Russia (RU)',

  // Short text supplement
  'cdn.common.enabledShort': 'Enabled',
  'cdn.common.disabledShort': 'Disabled',

  // HTTPS form
  'cdn.https.form.enableHttps': 'Enable HTTPS',
  'cdn.https.form.autoCert': 'Auto-request Certificate',
  'cdn.https.form.autoCertTip':
    'System will automatically request a TLS certificate via ACME. No need to fill in certificate content.',
  'cdn.https.form.httpRedirect': 'Force HTTP to HTTPS Redirect',
  'cdn.https.form.certPublicKey': 'Certificate Public Key',
  'cdn.https.form.certAutoCertPlaceholder':
    'Not needed when auto-cert is enabled',
  'cdn.https.form.certPublicKeyPlaceholder':
    'Paste PEM certificate content (-----BEGIN CERTIFICATE-----)',
  'cdn.https.form.certPrivateKey': 'Certificate Private Key',
  'cdn.https.form.certPrivateKeyPlaceholder':
    'Paste PEM private key content (-----BEGIN PRIVATE KEY-----)',

  // Geo form
  'cdn.geo.form.unknownAction': 'Unknown Region Handling',
  'cdn.geo.form.unknownActionTip':
    'Default action for requests from regions not matched by any rule',

  // Cache rules content validation
  'cdn.cache.rules.content.regexPlaceholder': '^/api/.* (regex)',
  'cdn.cache.rules.content.regexMsg': 'Please enter a valid regular expression',
  'cdn.cache.rules.content.suffixPlaceholder':
    '.jpg|.png|.css (start with ., separate by |)',
  'cdn.cache.rules.content.suffixMsg':
    'Suffix must start with ., e.g. .jpg|.png',
  'cdn.cache.rules.content.prefixPlaceholder': '/api/v1/ (start with /)',
  'cdn.cache.rules.content.prefixMsg': 'Prefix must start with /',
  'cdn.cache.rules.content.eqPlaceholder':
    '/index.html (exact path, start with /)',
  'cdn.cache.rules.content.eqMsg': 'Exact path must start with /',

  // Common supplement
  'cdn.common.value': 'Value',
  'cdn.common.matchContent': 'Match Content',
  'cdn.common.seconds': 'Seconds',
  'cdn.common.domain': 'Domain',

  // Cache rule columns
  'cdn.cache.rules.column.content': 'Match Content',
  'cdn.cache.rules.column.ttl': 'Cache TTL',
  'cdn.cache.rules.column.mode': 'Cache Mode',
  'cdn.cache.rules.column.range': 'Range Proxy',

  // Domain table
  'cdn.domain.table.getVerifyFailed': 'Failed to get verification info',
  'cdn.domain.table.verifySuccess': 'Verification successful',

  // Geo rules
  'cdn.geo.country.BR': 'Brazil (BR)',
  'cdn.geo.country.IN': 'India (IN)',
  'cdn.geo.country.AU': 'Australia (AU)',
  'cdn.geo.country.CA': 'Canada (CA)',
  'cdn.geo.country.SG': 'Singapore (SG)',
  'cdn.geo.country.HK': 'Hong Kong (HK)',
  'cdn.geo.country.TW': 'Taiwan (TW)',

  // Header table
  'cdn.header.table.requestHeader': 'Request Header',
  'cdn.header.table.responseHeader': 'Response Header',

  // Human verification
  'cdn.human.form.expiryTip':
    'Duration after passing verification, e.g. 60s, 5m, 1h',
  'cdn.human.rules.column.verifyPolicy': 'Verify Policy',

  // IP access control
  'cdn.ipAccess.rules.modal.title': 'Add IP Access Rule',
  'cdn.ipAccess.rules.form.ip': 'IP Address',
  'cdn.ipAccess.rules.form.ipPlaceholder': 'e.g. 192.168.1.1 or 192.168.1.0/24',
  'cdn.ipAccess.rules.form.policy': 'Access Policy',

  // Language rules
  'cdn.language.rules.modal.title': 'Add Language Rule',

  // Referer rules
  'cdn.referer.rules.modal.title': 'Add Hotlink Rule',
  'cdn.referer.rules.editTitle': 'Edit Hotlink Rule',
  'cdn.referer.rules.form.domainPlaceholder':
    'e.g. example.com, *.example.com or https://example.com',
  'cdn.referer.rules.column.matchType': 'Match Type',
  'cdn.referer.rules.matchType.wildcard': 'Wildcard',
  'cdn.referer.rules.matchType.equals': 'Equals',
  'cdn.referer.rules.matchType.startsWith': 'Starts With',
  'cdn.referer.rules.matchType.endsWith': 'Ends With',
  'cdn.referer.rules.matchType.contains': 'Contains',
  'cdn.referer.rules.matchType.regex': 'Regex',
  'cdn.referer.rules.required.matchType': 'Please select match type',

  // Upstream servers table
  'cdn.upstream.servers.column.remark': 'Remark',
  'cdn.upstream.form.lbLeastConn': 'Least Connections',
  'cdn.upstream.form.lbWeightedRR': 'Weighted Round Robin',

  // URL rewrite
  'cdn.urlRewrite.rules.modal.title': 'Add URL Rewrite Rule',
  'cdn.urlRewrite.rules.form.pattern': 'Match Pattern',
  'cdn.urlRewrite.rules.form.patternPlaceholder': 'e.g. ^/old/(.*)$',
  'cdn.urlRewrite.rules.form.replacement': 'Replacement',

  // UA rules
  'cdn.ua.rules.modal.title': 'Add UA Control Rule',
  'cdn.ua.rules.form.uaPlaceholder': 'e.g. Mozilla/5.0 or keyword fragment',

  // Site list (oper)
  'cdn.site.list.onlyMine': 'My Sites Only',
  'cdn.site.create.label.region': 'Region',
  'cdn.site.region.chineseMainland': 'Chinese Mainland',
  'cdn.site.region.global': 'Global',
  'cdn.site.region.globalExcludingCN': 'Global (Excl. CN)',
  'cdn.region.chinese_mainland': 'Chinese Mainland',
  'cdn.region.global': 'Global',
  'cdn.region.global_excluding_chinese_mainland':
    'Global (Excluding Chinese Mainland)',
  'cdn.region.selectPlaceholder': 'Select region',

  // Line management
  'cdn.line.create.button': 'Create Line',
  'cdn.line.create.title': 'Create Line',
  'cdn.line.edit.title': 'Edit Line',
  'cdn.line.create.required.name': 'Please enter line name',
  'cdn.line.create.placeholder.name': 'Please enter line name',
  'cdn.line.create.required.code': 'Please enter line code',
  'cdn.line.create.placeholder.code': 'Please enter line code, e.g. hk.free',
  'cdn.line.create.invalid.code':
    'Line code only supports lowercase letters, digits and hyphens, dot-separated segments allowed',
  'cdn.line.detail.error': 'Failed to get line detail',
  'cdn.line.detail.notFound': 'Line not found',
  'cdn.line.tab.basic': 'Basic Info',
  'cdn.line.tab.nodes': 'Node Configuration',
  'cdn.line.sideMenu.group.basic': 'Line Info',
  'cdn.line.sideMenu.backToList': 'Back to Line List',
  'cdn.line.tab.desc.basic':
    'View line basic information, including name, code, region, status, etc.',
  'cdn.line.tab.desc.nodes':
    'Manage nodes associated with the line, support batch add and delete.',
  'cdn.line.column.name': 'Line Name',
  'cdn.line.column.code': 'Line Code',
  'cdn.line.column.region': 'Region',
  'cdn.line.column.description': 'Description',
  'cdn.line.status.active': 'Active',
  'cdn.line.status.inactive': 'Inactive',
  'cdn.line.nodes.title': 'Line Node Configuration',
  'cdn.line.nodes.loadFailed': 'Failed to load node list',
  'cdn.line.nodes.loadAvailableFailed': 'Failed to load available nodes',
  'cdn.line.nodes.addSuccess': 'Node added successfully',
  'cdn.line.nodes.addFailed': 'Failed to add node',
  'cdn.line.nodes.deleteSuccess': 'Node deleted successfully',
  'cdn.line.nodes.deleteFailed': 'Failed to delete node',
  'cdn.line.nodes.selectAtLeastOne': 'Please select at least one node',
  'cdn.line.nodes.add': 'Add Node',
  'cdn.line.nodes.batchDelete': 'Batch Delete',
  'cdn.line.nodes.deleteConfirm': 'Are you sure you want to delete this node?',
  'cdn.line.nodes.batchDeleteConfirm':
    'Are you sure you want to delete selected nodes?',
  'cdn.line.nodes.deleteLastNodeConfirmTitle': 'Confirm to Delete Last Node',
  'cdn.line.nodes.deleteLastNodeConfirmContent':
    'This is the last node of this line. After deletion, this line will have no nodes. Are you sure you want to delete it?',
  'cdn.line.nodes.clearAllNodesConfirmTitle': 'Confirm to Remove All Nodes',
  'cdn.line.nodes.clearAllNodesConfirmContent':
    'This operation will remove all nodes from this line. Are you sure you want to continue?',
  'cdn.line.nodes.selectedCount': 'Selected {count} nodes',
  'cdn.line.nodes.selectModal.title': 'Select Nodes',
  'cdn.line.nodes.noNodes': 'No associated nodes',
  'cdn.line.nodes.emptyAvailable': 'No available nodes',
  'cdn.common.createdAt': 'Created At',
  'cdn.common.updatedAt': 'Updated At',

  // Node management
  'cdn.node.updateStatus.title': 'Update Node Status',
  'cdn.node.updateStatus.deviceCode': 'Device Code',
  'cdn.node.updateStatus.hostname': 'Hostname',
  'cdn.node.updateStatus.required.status': 'Please select a status',

  // Cache rule form supplement
  'cdn.cache.rules.form.contentPlaceholder': 'Enter match content',
  'cdn.cache.rules.form.ttlPlaceholder': 'Duration',
  'cdn.cache.rules.form.enableRule': 'Enable Rule',
  'cdn.cache.rules.form.enableRange': 'Enable Range Proxy',
  'cdn.cache.rules.form.enableRangeTooltip':
    'Include Range header in upstream requests to support partial content fetching',
  'cdn.cache.rules.form.ruleType': 'Rule Type',

  // Domain table form
  'cdn.domain.table.form.domainPlaceholder': 'e.g. example.com',
  'cdn.domain.table.form.required.domain': 'Please enter domain',
  'cdn.domain.table.form.invalidDomain': 'Please enter a valid domain format',
  'cdn.domain.table.action.verify': 'Verify',

  // Header table form
  'cdn.header.table.addHeader': 'Add Header',
  'cdn.header.table.form.headerType': 'Header Type',
  'cdn.header.table.form.headerName': 'Header Name',
  'cdn.header.table.form.headerNamePlaceholder': 'e.g. X-Custom-Header',
  'cdn.header.table.form.value': 'Header Value',
  'cdn.header.table.form.valuePlaceholder': 'Enter header value',
  'cdn.header.table.form.matchRegex': 'Match Regex',
  'cdn.header.table.form.matchRegexPlaceholder': 'Regex, e.g. ^(.*)$',
  'cdn.header.table.form.replacement': 'Replacement',
  'cdn.header.table.form.replacementPlaceholder': 'Replacement, e.g. $1-suffix',

  // Human rules modal
  'cdn.human.rules.modal.title': 'Add Human Verification Rule',
  'cdn.human.rules.form.required.name': 'Please enter rule name',
  'cdn.human.rules.form.matchMode': 'Match Mode',
  'cdn.human.rules.form.required.matchMode': 'Please select match mode',
  'cdn.human.rules.form.required.operator': 'Please select operator',
  'cdn.human.rules.form.matchContentTip': 'Separate multiple values with |',
  'cdn.human.rules.form.matchContentTipHeader':
    'Format: HeaderName:value, e.g. X-Custom-Header:value',
  'cdn.human.rules.form.contentPlaceholderHeader': 'e.g. X-Custom-Header:value',
  'cdn.human.rules.form.required.content': 'Please enter match content',
  'cdn.human.rules.form.required.policy': 'Please select verify policy',
  'cdn.human.rules.form.required.expiry': 'Please enter expiry',

  // Upstream servers detailed form
  'cdn.upstream.servers.add': 'Add Server',
  'cdn.upstream.servers.modal.addTitle': 'Add Upstream Server',
  'cdn.upstream.servers.modal.editTitle': 'Edit Upstream Server',
  'cdn.upstream.servers.form.address': 'Server Address',
  'cdn.upstream.servers.form.addressPlaceholder':
    'e.g. 192.168.1.1 or example.com',
  'cdn.upstream.servers.form.required.address': 'Please enter server address',
  'cdn.upstream.servers.form.required.port': 'Please enter port',
  'cdn.upstream.servers.column.hostname': 'Hostname',
  'cdn.upstream.servers.form.hostnamePlaceholder':
    'Host header value (optional)',
  'cdn.upstream.servers.form.hostnameTooltip':
    'Sets the Host header in requests, different from TLS SNI (tls_server_name)',
  'cdn.upstream.servers.form.remarkPlaceholder': 'Optional remark',
  'cdn.upstream.servers.tlsConfig': 'TLS Configuration',
  'cdn.upstream.servers.enableHttps': 'Enable HTTPS',
  'cdn.upstream.servers.httpsH2cConflict': 'Conflicting with H2C, disabled',
  'cdn.upstream.servers.http3AutoHttps': 'HTTP/3 enabled, HTTPS auto-enabled',
  'cdn.upstream.servers.useHttps': 'Use HTTPS for upstream connection',
  'cdn.upstream.servers.disableHttpsWarning':
    'Disabling HTTPS will ignore TLS configuration',
  'cdn.upstream.servers.protocolConfig': 'Protocol Configuration',
  'cdn.upstream.servers.advancedConfig': 'Advanced Configuration (Timeout)',
  'cdn.upstream.servers.storageAdvancedConfig':
    'Advanced Configuration (Timeout)',
  'cdn.upstream.servers.clientCert': 'Client Certificate',
  'cdn.upstream.servers.clientCertDesc':
    'For mutual TLS (mTLS): fill in when the upstream server requires client authentication. Leave empty for standard HTTPS. Both public and private key must be provided or both left empty.',
  'cdn.upstream.servers.clientCertPlaceholder':
    'Optional, for mTLS. Paste PEM certificate content (-----BEGIN CERTIFICATE-----)',
  'cdn.upstream.servers.clientCertTooltip':
    'mTLS client certificate. Not needed for standard HTTPS.',
  'cdn.upstream.servers.clientKey': 'Client Private Key',
  'cdn.upstream.servers.clientKeyPlaceholder':
    'Optional, for mTLS. Paste PEM private key content (-----BEGIN ... KEY-----)',
  'cdn.upstream.servers.clientKeyTooltip':
    'mTLS client private key. Not needed for standard HTTPS.',
  'cdn.upstream.servers.certPairError.missingKey':
    'Certificate provided, private key is required',
  'cdn.upstream.servers.certPairError.missingCert':
    'Private key provided, certificate is required',
  'cdn.upstream.servers.skipTls': 'Skip TLS Verification',
  'cdn.upstream.servers.skipTlsTooltip':
    'Skip upstream server certificate verification (not recommended for production)',
  'cdn.upstream.servers.caCert': 'CA Certificate',
  'cdn.upstream.servers.caCertPlaceholder':
    'Paste CA certificate content (optional, for verifying upstream)',
  'cdn.upstream.servers.connectTimeout': 'Connect Timeout',
  'cdn.upstream.servers.connectTimeoutTooltip':
    'Timeout for connecting to upstream (ms), default 3000ms',
  'cdn.upstream.servers.responseTimeout': 'Response Header Timeout',
  'cdn.upstream.servers.responseTimeoutTooltip':
    'Timeout waiting for response headers (ms), default 30000ms',
  'cdn.upstream.servers.maxConn': 'Max Connections per Host',
  'cdn.upstream.servers.maxConnTooltip':
    'Max concurrent connections to upstream, 0 means unlimited',
  'cdn.upstream.servers.maxConnPlaceholder': '0 (unlimited)',

  // URL access rule
  'cdn.urlAccess.rules.modal.title': 'Add URL Access Rule',
  'cdn.urlAccess.rules.form.contentPlaceholder': 'Enter URL match content',
  'cdn.urlAccess.rules.form.redirectPlaceholder':
    'e.g. https://example.com/new-path',

  // URL rewrite rule
  'cdn.urlRewrite.rules.form.replacementPlaceholder': 'e.g. /new/$1',

  // Geo rules form
  'cdn.geo.rules.form.regionPlaceholder':
    'Select or enter region code (e.g. CN, US)',

  // Language rules form
  'cdn.language.rules.form.langList': 'Language List',
  'cdn.language.rules.form.langListPlaceholder':
    'Separate with comma, e.g. zh-CN, en-US',
  'cdn.language.rules.form.redirectPlaceholder': 'e.g. https://example.com/',

  // Site create supplement
  'cdn.site.create.required.region': 'Please select a region',
  'cdn.site.create.label.subscriptionType': 'Subscription Type',
  'cdn.site.subscriptionType.basic': 'Basic',
  'cdn.site.subscriptionType.pro': 'Pro',
  'cdn.site.subscriptionType.enterprise': 'Enterprise',
  'cdn.common.tags': 'Tags',
  'cdn.site.create.tagsPlaceholder': 'Type tag then press Enter',
  'cdn.common.notSet': 'Not Set',
  'cdn.common.operator': 'Operator',
  'cdn.ua.rules.form.allow': 'Allow Access',
  'cdn.cache.rules.form.queryWhitelist': 'Query Param Whitelist',
  'cdn.cache.rules.form.whitelistParams': 'Whitelist Params',
  'cdn.cache.rules.form.whitelistParamsTip':
    'Only cache specified query parameter combinations. Separate multiple param names with commas, e.g. page,size,sort',
  'cdn.cache.rules.form.required.whitelistParams':
    'Please enter whitelist params',
  'cdn.cache.rules.form.whitelistParamsPlaceholder':
    'Separate multiple params with commas, e.g. page,size',
  'cdn.cache.rules.form.invalidParamNames':
    'Param names can only contain letters, digits, underscores, hyphens. Invalid',
  'cdn.upstream.servers.caCertTooltip':
    'Optional, used to verify upstream server certificate',
  'cdn.upstream.servers.skipTlsCaWarning':
    'CA certificate will be ignored when TLS verification is skipped',
  'cdn.upstream.servers.tlsSni': 'TLS SNI Name',
  'cdn.upstream.servers.tlsSniPlaceholder':
    'Server name for TLS handshake (max 255 characters)',
  'cdn.upstream.servers.tlsSniTooltip':
    'Optional, used to specify TLS SNI server name',
  'cdn.upstream.servers.h2c': 'H2C (Cleartext HTTP/2)',
  'cdn.upstream.servers.h2cConflict':
    'Currently conflicts with HTTPS/HTTP/3/Force HTTP/2, disabled',
  'cdn.upstream.servers.h2cDescription':
    'Enable cleartext HTTP/2 upstream, mutually exclusive with HTTPS and HTTP/3',
  'cdn.upstream.servers.http3Description':
    'HTTP/3 is based on QUIC protocol, requires TLS. Enabling it will automatically enable HTTPS and is mutually exclusive with H2C',
  'cdn.upstream.servers.http3Enabled': 'HTTP/3 (QUIC) Enabled',
  'cdn.upstream.servers.http3EnabledDesc':
    'QUIC protocol requires TLS, HTTPS has been automatically enabled. TLS certificate fields (client cert, CA cert) are still optional, same as regular HTTPS upstream.',
  'cdn.upstream.servers.forceHttp2': 'Force HTTP/2',
  'cdn.upstream.servers.forceHttp2Tip':
    'Attempt HTTP/2 upgrade even if upstream does not support it',
  'cdn.upstream.servers.h2cHttpsConflict':
    'H2C and HTTPS cannot be enabled simultaneously',
  'cdn.upstream.servers.h2cHttp3Conflict':
    'H2C and HTTP/3 cannot be enabled simultaneously',
  'cdn.upstream.servers.weightRange': 'Range',
  'cdn.upstream.servers.weightDefault': 'Default',
  'cdn.upstream.servers.origin_type': 'Origin Type',
  'cdn.upstream.servers.origin_type.http': 'HTTP/HTTPS Origin',
  'cdn.upstream.servers.origin_type.s3': 'S3-compatible Storage',
  'cdn.upstream.servers.origin_type.oss': 'Alibaba Cloud OSS',
  'cdn.upstream.servers.origin_type.cos': 'Tencent Cloud COS',
  'cdn.upstream.servers.storage_bucket': 'Bucket Name',
  'cdn.upstream.servers.storage_region': 'Storage Region',
  'cdn.upstream.servers.storage_endpoint': 'Custom Endpoint',
  'cdn.upstream.servers.storage_endpoint.tooltip.s3':
    'Leave empty for default endpoint. Fill in for S3-compatible storage (MinIO, Cloudflare R2, Ceph, etc.)',
  'cdn.upstream.servers.storage_endpoint.tooltip.oss':
    'Enter Alibaba Cloud OSS endpoint, e.g., oss-cn-hangzhou.aliyuncs.com',
  'cdn.upstream.servers.storage_endpoint.tooltip.cos':
    'Enter Tencent Cloud COS endpoint, e.g., cos.ap-guangzhou.myqcloud.com',
  'cdn.upstream.servers.storageAccessKey.title': 'Why is Access Key required?',
  'cdn.upstream.servers.storageAccessKey.reason':
    'When using object storage origin, CDN nodes need Access Key to sign and authenticate requests to access private storage buckets.',
  'cdn.upstream.servers.storageAccessKey.securityTitle':
    'Security recommendations:',
  'cdn.upstream.servers.storageAccessKey.tip1':
    'Create a dedicated read-only Access Key with only GetObject permission',
  'cdn.upstream.servers.storageAccessKey.tip2':
    'Never use Access Keys with write/delete permissions',
  'cdn.upstream.servers.storageAccessKey.tip3': 'Rotate Access Keys regularly',
  'cdn.upstream.servers.storageAccessKey.publicTitle':
    'Public storage alternative:',
  'cdn.upstream.servers.storageAccessKey.publicDesc':
    ' If your bucket is publicly readable, you can choose "HTTP/HTTPS Origin" to access via URL directly, without configuring Access Key, avoiding key leakage risks.',
  'cdn.upstream.servers.access_key_id': 'Access Key ID',
  'cdn.upstream.servers.access_key_secret': 'Access Key Secret',

  // Dashboard - Time selector
  'cdn.oper.dashboard.period.today': 'Today',
  'cdn.oper.dashboard.period.yesterday': 'Yesterday',
  'cdn.oper.dashboard.period.7d': 'Last 7 Days',
  'cdn.oper.dashboard.period.30d': 'Last 30 Days',

  // Dashboard - Access data label
  'cdn.oper.dashboard.accessData': 'Access Data',

  // Dashboard - Overview cards - dynamic titles
  'cdn.oper.dashboard.card.sites.today': 'Active Sites Today',
  'cdn.oper.dashboard.card.sites.yesterday': 'Active Sites Yesterday',
  'cdn.oper.dashboard.card.sites.7d': 'Active Sites (7 Days)',
  'cdn.oper.dashboard.card.sites.30d': 'Active Sites (30 Days)',
  'cdn.oper.dashboard.card.sites': 'My Sites',
  'cdn.oper.dashboard.card.sites.suffix': 'sites',

  'cdn.oper.dashboard.card.traffic.today': "Today's Traffic",
  'cdn.oper.dashboard.card.traffic.yesterday': "Yesterday's Traffic",
  'cdn.oper.dashboard.card.traffic.7d': '7-Day Traffic',
  'cdn.oper.dashboard.card.traffic.30d': '30-Day Traffic',
  'cdn.oper.dashboard.card.traffic': 'Monthly Traffic',

  'cdn.oper.dashboard.card.requests.today': "Today's Requests",
  'cdn.oper.dashboard.card.requests.yesterday': "Yesterday's Requests",
  'cdn.oper.dashboard.card.requests.7d': '7-Day Requests',
  'cdn.oper.dashboard.card.requests.30d': '30-Day Requests',
  'cdn.oper.dashboard.card.requests': 'Monthly Requests',
  'cdn.oper.dashboard.card.requests.suffix': 'requests',

  'cdn.oper.dashboard.card.cacheHitRate': 'Cache Hit Rate',

  // Dashboard - Chart titles
  'cdn.oper.dashboard.chart.traffic': 'Traffic Trend',
  'cdn.oper.dashboard.chart.requests': 'Request Trend',
  'cdn.oper.dashboard.chart.traffic.tooltip': 'Traffic',
  'cdn.oper.dashboard.chart.requests.tooltip': 'Requests',

  // Dashboard - Empty state
  'cdn.oper.dashboard.empty': 'No data available',

  // Node detail sidebar navigation
  'cdn.node.sideMenu.group.basic': 'Node Info',
  'cdn.node.sideMenu.backToList': 'Back to Node List',
  'cdn.node.tab.basic': 'Basic Info',
  'cdn.node.tab.config': 'Config Management',
  'cdn.node.tab.stats': 'Traffic Stats',
  'cdn.node.tab.desc.basic':
    'View node basic information including device code, IP address, region, status, etc.',
  'cdn.node.tab.desc.config':
    'Manage node configuration parameters, support inheriting global default config or customizing node-specific config.',
  'cdn.node.tab.desc.stats':
    'View node traffic statistics including request volume, bandwidth, cache hit rate, etc.',

  // Cache presets
  'cdn.cache.presets.button': 'Add from Preset',
  'cdn.cache.presets.title': 'Select Cache Preset',
  'cdn.cache.presets.description':
    'Select a preset rule set to quickly add cache rules',
  'cdn.cache.presets.applyMode': 'Apply Mode',
  'cdn.cache.presets.append': 'Append to existing rules',
  'cdn.cache.presets.replace': 'Replace all existing rules',
  'cdn.cache.presets.replaceConfirm':
    'Replacing will delete all existing cache rules. Continue?',
  'cdn.cache.presets.rulesCount': '{count} rules',
  'cdn.cache.presets.applySuccess': 'Preset rules applied successfully',
  'cdn.cache.presets.applyFailed': 'Failed to apply preset rules',
  'cdn.cache.presets.loading': 'Loading presets...',
};
